module.exports = __webpack_public_path__ + "img/MaidenofWaxResin.ff221540.png";